export const METHOD_LABELS: Record<string, string> = {
    AUTO_SCHEDULER_WEB: 'Auto Scheduler',
    LORI_STEP_WEB: 'Step Lori',
    LORI_ADVANCED_WEB: 'Advanced Lori',
    LORI_ADVANCED_MOBILE: 'Advanced Lori (Mobile)',
    BULK_ASSIGN_WEB: 'Bulk Assign',
    TURN_TEMPLATE_WEB: 'Turn Template',
    WALK_SCHEDULER_WEB: 'Walk Scheduler',
}

export const METHOD_COLORS: Record<string, string> = {
    AUTO_SCHEDULER_WEB: '#636EFA',
    LORI_STEP_WEB: '#EF553B',
    LORI_ADVANCED_WEB: '#00CC96',
    LORI_ADVANCED_MOBILE: '#AB63FA',
    BULK_ASSIGN_WEB: '#FFA15A',
    TURN_TEMPLATE_WEB: '#19D3F3',
    WALK_SCHEDULER_WEB: '#AB47BC',
}

export const METHOD_ORDER = [
    'AUTO_SCHEDULER_WEB',
    'LORI_STEP_WEB',
    'LORI_ADVANCED_WEB',
    'LORI_ADVANCED_MOBILE',
    'BULK_ASSIGN_WEB',
    'TURN_TEMPLATE_WEB',
    'WALK_SCHEDULER_WEB',
]

export const PRIMARY_METHOD_LABELS: Record<string, string> = {
    ...METHOD_LABELS,
    ASSIGN: 'Assign',
}

export const DEFAULT_CAI_PASS_THRESHOLD = 70

export const YEAR_GROUP_GAP = 1

export type TableFilters = {
    primaryMethod: string | 'ALL'
    year: number | 'ALL'
    apartmentSearch: string
    caiThreshold: 'ALL' | 'PASS' | 'FAIL'
}

export const DEFAULT_TABLE_FILTERS: TableFilters = {
    primaryMethod: 'ALL',
    year: 'ALL',
    apartmentSearch: '',
    caiThreshold: 'ALL',
}

export type SortField =
    | 'apartment_name'
    | 'year'
    | 'schedule_name'
    | 'primary_method'
    | 'total'
    | 'cai_count'
    | 'cai_rate'
    | 'met_threshold'

export type SortDirection = 'asc' | 'desc'

export const DEFAULT_SORT_FIELD: SortField = 'cai_rate'
export const DEFAULT_SORT_DIRECTION: SortDirection = 'desc'

export const meetsCaiThreshold = (
    caiRate: number,
    thresholdPercent: number = DEFAULT_CAI_PASS_THRESHOLD,
): boolean => caiRate >= thresholdPercent / 100

export const hasActiveTableFilters = (filters: TableFilters): boolean =>
    filters.primaryMethod !== 'ALL' ||
    filters.year !== 'ALL' ||
    filters.apartmentSearch.trim() !== '' ||
    filters.caiThreshold !== 'ALL'
